// Predefined module tags shared by the bug report list, the detail page and
// the create modal. Keep alphabetically sorted (Dutch collation).
export const PREDEFINED_BUG_REPORT_TAGS: string[] = [
  'Acquisitie',
  'Algemeen',
  'Bedrijven',
  'Bestanden',
  'Contacten',
  'Corporate',
  'Documentgenerator',
  'E-mail module',
  'Ella AI',
  'Financieel',
  "Foto's",
  'Gebouwen',
  'Helpdesk',
  'Huurders communicatie',
  'Indexatie',
  'Leveranciers communicatie',
  'Renovatie',
  'Taken',
  'Verhuur',
  'Verzekeringen',
  'WhatsApp',
  'Zoekbalk',
];
